export enum IdpSource {
  Entra = 'entra',
  Okta = 'okta',
}

export function getIdpLabel(idpSource: IdpSource | null | undefined | string): string {
  if (idpSource === null || idpSource === undefined) return 'Unknown';
  // Normalize to lowercase to handle both enum value ('entra') and enum name ('Entra') from backend
  const normalized = (typeof idpSource === 'string' ? idpSource.toLowerCase() : idpSource) as string;
  return normalized === IdpSource.Entra ? 'Entra' : 'Okta';
}

export function getIdpIconClass(idpSource: IdpSource | null | undefined | string): string {
  if (idpSource === null || idpSource === undefined) return '';
  // Normalize to lowercase to handle both enum value ('entra') and enum name ('Entra') from backend
  const normalized = (typeof idpSource === 'string' ? idpSource.toLowerCase() : idpSource) as string;
  // Return PrimeNG cloud icon class for Okta users only
  return normalized === IdpSource.Okta ? 'pi pi-cloud' : '';
}

export function getIdpIconColor(idpSource: IdpSource | null | undefined | string): string {
  if (idpSource === null || idpSource === undefined) return '';
  // Normalize to lowercase to handle both enum value ('entra') and enum name ('Entra') from backend
  const normalized = (typeof idpSource === 'string' ? idpSource.toLowerCase() : idpSource) as string;
  // Return orange color for Okta users only
  return normalized === IdpSource.Okta ? '#ff9500' : '';
}
